import { TFunction } from 'next-i18next'
import { RegisterOptions } from 'react-hook-form'

export const requiredValidation =
  (t: TFunction) =>
  (name: string): RegisterOptions => ({
    // The name should match the localisations in 'consumerLending:error:required_${name}`
    required: t('consumerLending:error:required', { context: name }) as unknown as string,
  })
